import { Avatar, Box, useMediaQuery, useTheme } from "@mui/material";
import React, { useState } from "react";
import { showIconByServiceId } from "../../../helper/showIconByServiceId";
import { Styles } from "./styles";
import EditableField from "./EditableField";
import SectionCard from "./SectionCard";

const OrderDetailsPage = ({ data = {} }) => {
  const [editingSection, setEditingSection] = useState(null);
  const [formData, setFormData] = useState(data);
  const theme = useTheme();
  // Configuration for editable fields

  const safeMap = (array, callback) => {
    if (!Array.isArray(array)) return null;
    return array.map(callback);
  };
  const renderSectionContent = (section) => {
    if (!formData[section]) return null;

    return Object.entries(formData[section]).map(([key, value]) => (
      <EditableField
        key={key}
        label={key
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ")}
        value={value}
        field={key}
        parent={section}
        setFormData={setFormData}
        formData={formData}
        editingSection={editingSection}
      />
    ));
  };
  return (
    <Styles>
      <Box
        sx={{
          display: "flex",
          overflowX: "auto",
          pb: 2,
          "&::-webkit-scrollbar": { height: 8 },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: theme.palette.primary.main,
            borderRadius: 4,
          },
        }}
      >
        {/* Order Details Card */}
        <SectionCard
          title="Order Details"
          sectionKey="order"
          icon="📦"
          setEditingSection={setEditingSection}
          setFormData={setFormData}
          editingSection={editingSection}
          data={data}
        >
          <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
            {formData?.our_service ? (
              <Avatar
                src={showIconByServiceId(formData.our_service?.our_service_id)}
                sx={{ width: 40, height: 40, boxShadow: 1 }}
              />
            ) : (
              safeMap(formData?.offerDetails, (item, idx) => (
                <Avatar
                  key={idx}
                  src={showIconByServiceId(item?.offer_id)}
                  sx={{ width: 40, height: 40, boxShadow: 1 }}
                />
              ))
            )}
          </Box>
          <EditableField
            label="Service Name"
            value={formData?.our_service?.name || formData?.offerName}
            field="name"
            parent={formData?.our_service ? "our_service" : null}
            setFormData={setFormData}
            formData={formData}
            editingSection={editingSection}
          />
          {[
            "user",
            "panel_url",
            "created_at",
            "payment_method",
            "price",
            "status",
          ].map(
            (key) =>
              formData[key] && (
                <EditableField
                  key={key}
                  label={key.replace("_", " ")}
                  value={
                    typeof formData[key] === "object"
                      ? formData[key]?.name
                      : formData[key]
                  }
                  field={key}
                  parent={typeof formData[key] === "object" ? key : null}
                  setFormData={setFormData}
                  formData={formData}
                  editingSection={editingSection}
                />
              )
          )}
        </SectionCard>

        {/* Additional Cards */}
        {["tickets_ads", "top_result", "pin", "banner", "trust"].map(
          (section) =>
            formData[section] && (
              <SectionCard
                key={section}
                title={section.replace("_", " ")}
                sectionKey={section}
                icon={
                  {
                    tickets_ads: "🎫",
                    top_result: "🔍",
                    pin: "📌",
                    banner: "🖼️",
                    trust: "✔️",
                  }[section]
                }
                setEditingSection={setEditingSection}
                setFormData={setFormData}
                editingSection={editingSection}
                data={data}
                formData={formData}
              >
                {renderSectionContent(section)}
              </SectionCard>
            )
        )}
      </Box>
    </Styles>
  );
};

export default OrderDetailsPage;
